import React, { Component } from "react";
import ReadAxios from "../axiosComponent/read";
// import MiniPlaceholder from "./miniPlaceHolder";
import { translate } from "react-i18next";
import isEmpty from "lodash/isEmpty";

export class GetState extends Component {
  constructor(props) {
    super(props);

    this.state = {
      state: [],
    };
  }

  async componentDidMount() {
    let dataArray =
      (await ReadAxios({
        completeURL: `${process.env.REACT_APP_MASTER_API}/stateMaster/${this.props.stateId}`,
      })) || [];
    dataArray = isEmpty(dataArray) ? [] : dataArray.data.resultSet;
    this.setState({ state: dataArray || [] });
  }

  render() {
    const { t } = this.props;
    const { state } = this.state;

    return (
            <span>{state.length > 0 ? state[0].state : "NA"}</span>
    ) 
  }
}

export default translate("shipment")(GetState);
